<div class="affiliates-claim-modal__top">
  <div class="affiliates-claim-modal__top--wrapper">
    <div class="affiliates-claim-modal__top--text">
      Claim your Free
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/core/skins.svg"
      ></svg-icon>
      1 Coin and 3 Free Cases
    </div>
    <span class="affiliates-claim-modal__top--line"></span>
    <div class="affiliates-claim-modal__top--background"></div>
  </div>
</div>
<p class="affiliates-claim-modal__description">
  In order to claim you will need to fulfill the requirements below:
</p>
<div class="affiliates-claim-modal__requirements">
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="hasReferral()"
    >
      <p class="affiliates-claim-modal__requirement--description">
        Use an <span>Affiliate</span> code
      </p></app-checkbox
    >
  </div>
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="(sessionService.profile()?.level ?? 0) >= 5"
      ><p class="affiliates-claim-modal__requirement--description">
        Be Level 5 on
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/ui/steam.svg"
        ></svg-icon>
        <span> Steam</span>
      </p></app-checkbox
    >
  </div>
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="
        sessionService.discord().linked && sessionService.discord().joined
      "
    >
      <p class="affiliates-claim-modal__requirement--description">
        Join our
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/socials/discord.svg"
        ></svg-icon>
        <span>Discord</span> server and
        <span
          (click)="$event.stopPropagation(); sessionService.authDiscord()"
          style="cursor: pointer"
        >
          VERIFY
        </span>
        you joined
      </p>
    </app-checkbox>
  </div>
</div>
<form
  class="affiliates-claim-modal__claim-form"
  (submit)="handleClaimAffiliateCode($event)"
>
  <s-form-field
    label="Affiliate Code"
    placeholder="Type your code..."
    id="affiliate-code"
    [field]="codeForm.code"
    [error]="codeFormApiError()"
    [errorType]="'outline'"
  />
  <button
    [disabled]="
      codeForm().submitting() ||
      codeForm().invalid() ||
      fieldLocked() ||
      isLoading()
    "
    class="affiliates-claim-modal__claim-form--submit-button"
    type="submit"
  >
    Reedem Code
  </button>
</form>
@if (!affiliatesService.basicsLoading()) {
  @if (basicsUnknown()) {
    <p class="affiliates-claim-modal__claim-form--hint">
      {{
        socketService.connected()
          ? affiliatesService.basicsFailed()
            ? "Couldn't load your referral state — press Refresh."
            : 'Waiting for your referral state — press Refresh.'
          : 'Waiting for your referral state — reconnecting…'
      }}
    </p>
  } @else if (affiliatesService.basicsFailed()) {
    <p class="affiliates-claim-modal__claim-form--hint">
      Couldn't refresh — showing last known state.
    </p>
  }
}
<div class="affiliates-claim-modal__prizes">
  <div class="affiliates-claim-modal__prize">
    @if (affiliatesService.affiliateCase(); as c) {
      <img
        class="affiliates-claim-modal__prize--image"
        [src]="c.image"
        [alt]="c.name"
      />
      <p class="affiliates-claim-modal__prize--name">
        {{ c.name }}
      </p>
      <button
        class="affiliates-claim-modal__prize--button"
        [class.green]="affiliatesService.isAffiliateCaseAvailable()"
        [class.black]="!affiliatesService.isAffiliateCaseAvailable()"
        [routerLink]="['/affiliates/cases', c.link]"
        [disabled]="!affiliatesService.isAffiliateCaseAvailable() || isLoading()"
        (click)="affiliatesService.isAffiliateCaseAvailable() && closeModal()"
      >
        {{
          affiliatesService.isAffiliateCaseAvailable()
            ? "Claim"
            : "Unavailable"
        }}
      </button>
    } @else {
      <div
        class="affiliates-claim-modal__prize--skeleton"
        [class.pulsing]="affiliatesService.caseLoading()"
      ></div>
      <p class="affiliates-claim-modal__prize--name">Free case</p>
      <button
        class="affiliates-claim-modal__prize--button black"
        disabled
      >
        Unavailable
      </button>
    }
  </div>
  <div class="affiliates-claim-modal__prize">
    <img
      class="affiliates-claim-modal__prize--image"
      [class.claimed]="coinsClaimed()"
      src="assets/images/affiliates/affiliates-coins.png"
      alt="Prize 2"
    />
    <p class="affiliates-claim-modal__prize--name">
      1
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/core/skins.svg"
      ></svg-icon>
      free coins
    </p>
    @if (!coinsClaimed()) {
      <button
        class="affiliates-claim-modal__prize--button"
        animate.leave="fade-out"
        [class.green]="affiliatesService.bonuses()?.balance"
        [class.black]="!affiliatesService.bonuses()?.balance"
        (click)="claimBalance()"
        [disabled]="
          !affiliatesService.bonuses()?.balance || isLoading() || claiming()
        "
      >
        @if (claiming()) {
          <app-loading-icon
            class="affiliates-claim-modal__button-spinner"
            color="currentColor"
            size="18px"
          />
        } @else {
          {{ affiliatesService.bonuses()?.balance ? "Claim" : "Unavailable" }}
        }
      </button>
      @if (claimError()) {
        <p
          class="affiliates-claim-modal__prize--error"
          animate.enter="fade-in"
        >
          {{ claimError() }}
        </p>
      }
    }
  </div>
</div>
<button
  class="affiliates-claim-modal__refresh"
  [disabled]="isLoading()"
  (click)="refreshBalance()"
>
  @if (isLoading()) {
    <app-loading-icon
      class="affiliates-claim-modal__button-spinner"
      color="currentColor"
      size="18px"
    />
  } @else {
    Refresh
  }
</button>
